import { render, staticRenderFns } from "./De.vue?vue&type=template&id=119f4dec&scoped=true&"
import script from "./De.vue?vue&type=script&lang=js&"
export * from "./De.vue?vue&type=script&lang=js&"
import style0 from "./De.vue?vue&type=style&index=0&id=119f4dec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f4dec",
  null
  
)

export default component.exports